










import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "TimePickerButton",
  props: {
    selected: { type: Boolean, default: false },
  },
});
